import { BasicSeoType, SeoType } from '@/types/seo';

const imagePrefix =
  'https://hivemapper-static.s3.us-west-2.amazonaws.com/website/public/seo/';

const imageFormat = '.jpg';

export const defaultSeo: SeoType = {
  title: 'Hivemapper - Build a Decentralized Global Map',
  description:
    "Hivemapper is building a decentralized global map of the world. Join our network and take part in building a map of the world that's accessible to everyone.",
  keywords:
    'Hivemapper, Contribute, Drive to Earn, Map AI Training Games, HONEY Rewards, Community Mapping, Global Map Data, Fleet Mapping Solutions, Drive and Earn, AI-Powered Mapping, Real-Time Map Updates',
  image: `${imagePrefix}Hivemapper_Generic_v1${imageFormat}`,
};

export const seo: BasicSeoType = {
  '/': {
    title: 'Hivemapper | Real-Time Global Street-Level Mapping',
    description:
      'Join Hivemapper’s global network of people, cameras, and apps to map the world in real time. Built by thousands, growing by millions — explore our live coverage now.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_Homepage_v3${imageFormat}`,
  },
  '/coverage': {
    title: 'Coverage | Hivemapper Global Road Mapping',
    description:
      'Explore Hivemapper’s interactive coverage map: over 500M+ KM of roads mapped and 34% of the world’s roads captured. Search any location to see live, up-to-date coverage.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_Coverage_v4${imageFormat}`,
  },
  '/network/contributors': {
    title: 'Contributors | Hivemapper Mapping Community',
    description:
      'Discover the people powering Hivemapper: track contributor growth, join dates, and last-seen activity as our global community maps the world in real time.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_Contributors_v4${imageFormat}`,
  },
  '/network/regions': {
    title: 'Regions | Hivemapper Regional Coverage Insights',
    description:
      'Dive into region-specific mapping stats: view percent mapped, incentive multipliers, and in-depth coverage insights for every region on the Hivemapper Network.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_Regions_v4${imageFormat}`,
  },
  '/privacy/overview': {
    title: 'Privacy Overview | Hivemapper',
    description:
      'Get a clear overview of how Hivemapper collects, uses, and protects data across our global mapping network. Transparency and control you can trust.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_PrivacyOverview_v1${imageFormat}`,
  },
  '/privacy/privacy-policy': {
    title: 'Privacy Policy | Hivemapper',
    description:
      'Review Hivemapper’s Privacy Policy for full details on data collection, storage, usage, and your rights. Learn how we safeguard your personal information.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_PrivacyPolicy_v1${imageFormat}`,
  },
  '/privacy/redaction-request': {
    title: 'Redaction Request | Hivemapper',
    description:
      'Submit a request to blur or remove sensitive imagery from the Hivemapper Network. We honor redaction requests quickly to protect your privacy.',
    keywords: defaultSeo.keywords,
    image: `${imagePrefix}Hivemapper_RedactionRequest_v1${imageFormat}`,
  },
};
